import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { LinkedInURLGenerator } from '@/features/linkedin-url-generator'

const searchSchema = z.object({
  filter:        z.string().optional().catch(''),
  stages:        z.array(z.string()).optional().catch([]),
  countries:     z.array(z.string()).optional().catch([]),
  cities:        z.array(z.string()).optional().catch([]),
  foundedYears:  z.array(z.number()).optional().catch([]),
  sectors:       z.array(z.string()).optional().catch([]),
  flags:         z.array(z.string()).optional().catch([]),
  investors:     z.array(z.string()).optional().catch([]),
  fundingRanges: z.array(z.string()).optional().catch([]),
  empRanges:     z.array(z.string()).optional().catch([]),
  xcornRatings:  z.array(z.string()).optional().catch([]),
})

export type LinkedInBuilderSearchParams = z.infer<typeof searchSchema>

export const Route = createFileRoute(
  '/_authenticated/linkedin/sales-navigator/builder'
)({
  validateSearch: searchSchema,
  component: LinkedInURLGenerator,
})
